import { render, staticRenderFns } from "./IvrStep.vue?vue&type=template&id=367981e0&"
import script from "./IvrStep.vue?vue&type=script&lang=ts&"
export * from "./IvrStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports